import { useEffect, useState } from 'react';
import fallback from '../data/fallback';
import { apiFetch } from './client';

export function useApi(endpoint, fallbackKey) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        const result = await apiFetch(endpoint);
        if (active) {
          setData(result);
          setError(null);
        }
      } catch (err) {
        if (active && fallbackKey && fallback[fallbackKey]) {
          setData(fallback[fallbackKey]);
          setError(null);
        } else if (active) {
          setError(err.message);
        }
      } finally {
        if (active) setLoading(false);
      }
    }

    load();

    return () => {
      active = false;
    };
  }, [endpoint, fallbackKey]);

  return { data, loading, error };
}
